export const SET_MENU_ACTIVE = 'SET_MENU_ACTIVE';